module.exports = __webpack_public_path__ + "img/sld_ch_1_t1_green.38bfe1cd.svg";